import { Component } from "react";
import { AlertTriangle, RotateCw, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API } from "@/lib/api";

const report = (error, info) =>
  fetch(`${API}/client-error`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      message: String(error?.message || error).slice(0, 500),
      stack: String(error?.stack || "").slice(0, 2000),
      component: String(info?.componentStack || "").slice(0, 1500),
      url: window.location.pathname,
    }),
  }).catch(() => {});

// Se una pagina va in errore mostra un messaggio chiaro invece della schermata bianca.
export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    report(error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="page-error-fallback">
        <div className="max-w-md w-full rounded-2xl border border-border bg-card p-6 text-center shadow-sm">
          <div className="w-12 h-12 mx-auto rounded-xl bg-amber-50 text-amber-600 dark:bg-amber-950/50 dark:text-amber-400 flex items-center justify-center">
            <AlertTriangle className="w-6 h-6" />
          </div>
          <h2 className="mt-4 font-heading text-lg font-bold">Questa pagina ha avuto un problema</h2>
          <p className="mt-1.5 text-sm text-muted-foreground">I tuoi dati sono al sicuro. Ricarica la pagina per continuare.</p>
          <div className="mt-5 flex flex-col sm:flex-row gap-2 justify-center">
            <Button onClick={() => window.location.reload()} data-testid="page-error-reload-button">
              <RotateCw className="w-4 h-4 mr-2" /> Ricarica pagina
            </Button>
            <Button variant="outline" onClick={() => window.location.assign("/")} data-testid="page-error-home-button">
              <Home className="w-4 h-4 mr-2" /> Torna alla Home
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
